import { TYPE_TAGS } from '@/components/artifact/panelMeta';

import type { ChatPanel } from '../../../../../bridge/types/state.ts';

export const humanizeType = (s: string): string =>
	s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const shouldShowBackChevron = (history: ChatPanel[]): boolean => {
	const top = history[history.length - 1];
	if (!top || top.panel_type !== 'process') return false;
	const status = top.process?.status;
	return status === 'active' || status === 'paused';
};

export const getChatPanelLabel = (panel: ChatPanel): string => {
	switch (panel.panel_type) {
		case 'process': {
			const title = panel.process?.content?.title;
			if (typeof title === 'string' && title.trim().length > 0) return title;
			return 'Campaign';
		}
		case 'artifact': {
			const t = panel.artifact?.type ?? panel.artifact_type;
			if (t && TYPE_TAGS[t]) return TYPE_TAGS[t];
			if (t) return humanizeType(t);
			return 'Item';
		}
		case 'process_recipients':
			return 'Recipients';
		case 'process_schedule':
			return 'Schedule';
		case 'action':
			return 'Action';
		case 'curated_insight':
			return panel.insight?.title?.trim() || 'Insight';
		case 'strategy':
			return 'Strategy';
	}
};
